import { defineComponent as d, createVNode as p, renderSlot as n, h as v } from "vue";
import { useSameTarget as y } from "./index653.js";
import { PatchFlags as o } from "./index654.js";
import { buildProps as f, definePropType as s } from "./index601.js";
import { useNamespace as x } from "./index559.js";
const k = f({
  mask: {
    type: Boolean,
    default: !0
  },
  customMaskEvent: Boolean,
  overlayClass: {
    type: s([
      String,
      Array,
      Object
    ])
  },
  zIndex: {
    type: s([String, Number])
  }
}), C = {
  click: (e) => e instanceof MouseEvent
}, M = "overlay";
var z = d({
  name: "ElOverlay",
  props: k,
  emits: C,
  setup(e, { slots: t, emit: a }) {
    const r = x(M), l = (u) => {
      a("click", u);
    }, { onClick: i, onMousedown: c, onMouseup: m } = y(
      e.customMaskEvent ? void 0 : l
    );
    return () => e.mask ? p(
      "div",
      {
        class: [r.b(), e.overlayClass],
        style: {
          zIndex: e.zIndex
        },
        onClick: i,
        onMousedown: c,
        onMouseup: m
      },
      [n(t, "default")],
      o.STYLE | o.CLASS | o.PROPS,
      ["onClick", "onMouseup", "onMousedown"]
    ) : v(
      "div",
      {
        class: e.overlayClass,
        style: {
          zIndex: e.zIndex,
          position: "fixed",
          top: "0px",
          right: "0px",
          bottom: "0px",
          left: "0px"
        }
      },
      [n(t, "default")]
    );
  }
});
export {
  z as default,
  C as overlayEmits,
  k as overlayProps
};
